// In this file, all Page components from 'src/pages` are auto-imported. Nested
// directories are supported, and should be uppercase. Each subdirectory will be
// prepended onto the component name.
//
// Examples:
//
// 'src/pages/HomePage/HomePage.js'         -> HomePage
// 'src/pages/Admin/BooksPage/BooksPage.js' -> AdminBooksPage

import { Router, Route, Set } from '@redwoodjs/router'
import BaseLayout from './layouts/BaseLayout/BaseLayout'

const Routes = () => {
  return (
    <Router>
      <Set wrap={BaseLayout}>
        <Route path="/" page={HomePage} name="home" />
        <Route path="/product" page={ProductPage} name="product" />
        <Route path="/license" page={LicensePage} name="license" />
        <Route path="/discount" page={DiscountPage} name="discount" />
        <Route path="/subscription" page={SubscriptionPage} name="subscription" />
        <Route path="/order" page={OrderPage} name="order" />
        <Route notfound page={NotFoundPage} />
      </Set>
    </Router>
  )
}

export default Routes
